import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollegePredictorComponent } from './college-predictor.component';
import { CollegePredictorListingComponent } from './college-predictor-listing/college-predictor-listing.component';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { CollegeFilterPipe } from './college-filter.pipe';
import { CollegePredictorService } from './college-predictor.service';
const route: Routes = [
  {
    path: '', component: CollegePredictorComponent
  },
  {
    path:':exam', component:CollegePredictorComponent
  }
];

@NgModule({
  declarations: [
    CollegePredictorComponent,
    CollegePredictorListingComponent,
    CollegeFilterPipe,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(route),
    SharedModule
  ],
  providers :[CollegePredictorService]
})
export class CollegePredictorModule { }
